import inventory from './inventory';
import order from './order';
import user from './user';
import profile from './profile';
import cart from './cart';
import checkout from './checkout'
import registration from './registration';
import voucherAssign from './voucher-assign';
import quotationRequest from './quotation_request';

export default {
  inventory,
  order,
  user,
  profile,
  cart,
  checkout,
  registration,
  voucherAssign,
  quotationRequest,
}
